import React from 'react'
import LockerMenu from '../../Components/LockerMenu'
import { PageWrapper } from '../../Styles/style'
import Header from '../../Sections/S1-Header'
import Categories from '../../Sections/S2-Categories'
import Projects from '../../Sections/S3-Projects'
import WhatAICM from '../../Sections/S4-WhatAICM'
import AICMAudits from '../../Sections/S5-AICMAudits'
import TokenUtility from '../../Sections/S6-TokenUtility'
import Roadmap from '../../Sections/S7-Roadmap'
import Footer from '../../Sections/S8-Footer'
import Loader from '../../Components/LockerMenu/component/Loader'

const MainPage = (props) => {
  return (
    
    <PageWrapper>
        <Header/>
        <Categories/>
        <Projects/>
        <WhatAICM/>
        <AICMAudits/>
        <TokenUtility/>
        <Roadmap/>
        <Footer/>
    </PageWrapper>
    
  )
}

export default MainPage